import Swiper from 'swiper';

import 'swiper/css';
//import 'swiper/css/vertical';

export default function awardsSliders(element, data) {
    const yearsSlider = element.querySelector(".years-slider");
    const years = yearsSlider.querySelectorAll(".swiper-slide");
    const awardsScrollers = element.querySelectorAll(".awards-scroller");

    if (window.innerWidth > 960) {
        const slidesPerView = 5;
        const half = Math.floor(slidesPerView / 2); // 2 slides above/below the centered one
        const count = years.length;
        // Range of indices that can sit in the centered position without leaving
        // empty space at the top/bottom. Outside this range the slider stays put
        // and only the selected item moves.
        const minCenter = half;
        const maxCenter = Math.max(half, count - 1 - half);
        const clampCenter = (index) => Math.min(Math.max(index, minCenter), maxCenter);

        const yearsSwiper = new Swiper(yearsSlider.querySelector('.swiper'), {
            direction: 'vertical',
            centeredSlides: true,
            slidesPerView,
            speed: 500,
            // Let Swiper mark the centered slide with its own class; the visual
            // "selected" state (.swiper-slide-active) is driven manually below so
            // the selection can ride the edges without scrolling the slider.
            slideActiveClass: 'swiper-slide-centered',
        });

        const prevButton = yearsSlider.querySelector('.swiper-button-prev');
        const nextButton = yearsSlider.querySelector('.swiper-button-next');
        let selected = -1;

        function selectYear(index) {
            const next = Math.min(Math.max(index, 0), count - 1);
            if (next === selected) return;
            selected = next;

            yearsSwiper.slideTo(clampCenter(selected), 500, false);

            years.forEach((year, i) => {
                year.classList.toggle('swiper-slide-active', i === selected);
            });

            prevButton?.classList.toggle('swiper-button-disabled', selected === 0);
            nextButton?.classList.toggle('swiper-button-disabled', selected === count - 1);

            setVisibleScroller(selected);
        }

        years.forEach((year, index) => {
            year.addEventListener("click", () => selectYear(index));
        });

        // Top arrow moves toward the first (top) year, bottom arrow toward the last.
        prevButton?.addEventListener('click', () => selectYear(selected - 1));
        nextButton?.addEventListener('click', () => selectYear(selected + 1));

        selectYear(0);
    } else {
        years.forEach((element, index) => {
            element.addEventListener("click", function () {
                element.classList.add(".swiper-slide-active");
                setVisibleScroller(index);
            });
        });
    }

    setVisibleScroller(0);

    function setVisibleScroller(index) {
        for (let i = 0; i < awardsScrollers.length; i++) {
            const scroller = awardsScrollers.item(i);
            if (i == index) {
                scroller?.classList?.add("active");
                scroller?.querySelectorAll('[data-widget="scrollerHorizontal"]').forEach(s => s.dispatchEvent(new Event('start')));
            } else {
                scroller?.classList?.remove("active");
                scroller?.querySelectorAll('[data-widget="scrollerHorizontal"]').forEach(s => s.dispatchEvent(new Event('stop')));
            }
        }

        if (window.innerWidth <= 960) {
            years.forEach((element, i) => {
                if (i == index) {
                    element.classList.add("swiper-slide-active");
                } else {
                    element.classList.remove("swiper-slide-active");
                }
            });

        }
    }
}